/* HomeKind v2 global behaviour (phase 1): back to top, announcement rotator,
   moving benefit strips. No dependencies, no storage, nothing persisted.

   Scroll work reads only scrollY and innerHeight (no layout reads), and timers
   are plain intervals rather than animation frames, because the in-app browser
   pane is treated as a hidden tab and rAF never fires there. */
(function () {
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
  var wide = window.matchMedia("(min-width: 1024px)");

  /* Horizon's cart drawer is a <dialog>, its menu drawer a <details>. */
  function drawerOpen() {
    return !!document.querySelector("dialog[open], #Details-menu-drawer-container[open], .hkv2c .drawer[open]");
  }

  /* ---------- back to top ---------- */
  var top = document.getElementById("hkv2-totop");
  if (top) {
    var shown = false;
    /* round 5: shows only while scrolling back up, hides after 2.5s without scrolling */
    var lastY = window.scrollY, up = false, idle = false, idleT = 0;
    window.addEventListener("scroll", function () {
      up = window.scrollY < lastY; lastY = window.scrollY; idle = false;
      clearTimeout(idleT);
      idleT = setTimeout(function () { if (top.contains(document.activeElement)) return; idle = true; syncTop(); }, 2500);
    }, { passive: true });
    /* round 6 (owner): whenever a sticky buy bar shows, the button rides 12px above it.
       Both bars publish their measured height as --hk-bar-h on <html> (0px when hidden). */
    var onBar = null;
    var syncBar = function () {
      var h = parseFloat(document.documentElement.style.getPropertyValue("--hk-bar-h")) || 0;
      if ((h > 0) === onBar) return;
      onBar = h > 0; top.classList.toggle("is-onbar", onBar);
    };
    if (window.MutationObserver) new MutationObserver(syncBar).observe(document.documentElement, { attributes: true, attributeFilter: ["style"] });
    syncBar();
    var welOpen = function () { var w = document.getElementById("welcome"); return !!(w && !w.hidden); };
    var syncTop = function () {
      var want = window.scrollY > window.innerHeight * 1.5 && !drawerOpen() && !welOpen() && up && !idle;
      if (want === shown) return;
      shown = want;
      top.classList.toggle("is-on", want);
      top.tabIndex = want ? 0 : -1;
      top.setAttribute("aria-hidden", want ? "false" : "true");
    };
    window.addEventListener("scroll", syncTop, { passive: true });
    window.addEventListener("resize", syncTop, { passive: true });
    /* drawers open and close on clicks and Escape; re-check just after */
    document.addEventListener("click", function () { setTimeout(syncTop, 60); }, true);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") setTimeout(syncTop, 60); });
    syncTop();
    top.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: reduce.matches ? "auto" : "smooth" });
      /* move focus as well as the viewport, or a keyboard user is left behind */
      var m = document.getElementById("MainContent");
      if (m) { m.setAttribute("tabindex", "-1"); m.focus({ preventScroll: true }); }
    });
  }

  /* ---------- announcement rotator ----------
     Rotates every few seconds below 1024px; at 1024px and up all messages sit in
     one static row (CSS) and the rotator idles. Paused by the button, by hover,
     by keyboard focus inside the bar, and under reduced motion. */
  var anns = document.querySelectorAll("[data-hkv2-ann]");
  Array.prototype.forEach.call(anns, function (ann) {
    var items = ann.querySelectorAll(".hkv2-ann__item");
    var btn = ann.querySelector(".hkv2-ann__pause");
    if (items.length < 2) { if (btn) btn.hidden = true; return; }
    var i = 0, userPaused = false, hover = false, focus = false;
    var every = Math.max(3, parseInt(ann.getAttribute("data-speed"), 10) || 6) * 1000;
    setInterval(function () {
      if (userPaused || hover || focus || reduce.matches || wide.matches || document.hidden) return;
      items[i].classList.remove("is-on");
      i = (i + 1) % items.length;
      items[i].classList.add("is-on");
    }, every);
    if (btn) btn.addEventListener("click", function () {
      userPaused = !userPaused;
      btn.setAttribute("aria-pressed", userPaused ? "true" : "false");
      btn.setAttribute("aria-label", userPaused ? "Play announcements" : "Pause announcements");
    });
    ann.addEventListener("mouseenter", function () { hover = true; });
    ann.addEventListener("mouseleave", function () { hover = false; });
    ann.addEventListener("focusin", function (e) { if (e.target !== btn) focus = true; });
    ann.addEventListener("focusout", function () { focus = false; });
  });

  /* ---------- moving benefit strips ----------
     Each .hkv2-marquee list is doubled so translateX(-50%) loops seamlessly. The
     copies are aria-hidden so a screen reader hears each item once. */
  var strips = document.querySelectorAll(".hkv2-marquee ul");
  Array.prototype.forEach.call(strips, function (ul) {
    if (ul.classList.contains("is-marq")) return;
    var items = ul.querySelectorAll("li");
    if (!items.length) return;
    Array.prototype.forEach.call(items, function (li) {
      var c = li.cloneNode(true);
      c.setAttribute("aria-hidden", "true");
      Array.prototype.forEach.call(c.querySelectorAll("a,button"), function (el) { el.tabIndex = -1; });
      ul.appendChild(c);
    });
    ul.classList.add("is-marq");
    ul.setAttribute("role", "list");
    if (ul.getAttribute("data-label")) ul.setAttribute("aria-label", ul.getAttribute("data-label"));
    ul.style.setProperty("--hkv2-marq-dur", Math.max(24, items.length * 4.5) + "s");
    var band = ul.closest(".hkv2-marquee");
    band.addEventListener("touchstart", function () { band.classList.add("is-held"); }, { passive: true });
    band.addEventListener("touchend", function () { setTimeout(function () { band.classList.remove("is-held"); }, 1500); }, { passive: true });
  });
})();
